<div class="main-content">
    <div class="main-heading">
        <strong> FDV - {{ pageTitle | capitalize}}</strong>
    </div>
    <ecpl-tab-navigation [linkItems]="enabledAdditionalFeatures" [parentId]="fdvId"></ecpl-tab-navigation>
    <div class="card">
        <div class="card-body">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>